<script>
    import {mapState} from 'vuex';
    import AnimationsMixin from "../../../author/pagesbuilder/mixins/AnimationsMixin";

    export default {
        name: "BundlePurchaseComponent",
        mixins: [AnimationsMixin],
        data () {
            return {
                componentType: "bundle-purchase",
                rendersWithVue: true
            }
        },
        computed : {
            ...mapState('products',[
                'bundles'
            ]),
            availableBundlePurchaseTemplates () {
                return [
                    {
                        templateFilename : "BundlePurchaseLayout1",
                        forSectionTemplates: [
                            "tpl-bundle-contents-2",
                            "tpl-bundle-contents-1",
                            "bun-tpl118",
                            "bun-tpl97",
                        ],
                    },
                    {
                        templateFilename : "BundlePurchaseLayout2",
                        forSectionTemplates: [],
                    },
                ];
            },
            getDefaultDataStructure () {
                //console.log('**** Getting DefaultDataStructure: ', this.componentType, this.componentId);
                return {
                    componentType: this.componentType,
                    componentId: this.componentId,
                    template: this.getDefaultTemplate,
                    styles: null,
                    itemVisibilitySettings: null
                }
            },
            getDefaultTemplate () {
                let sectionState = this.findNodeState(this.sectionId);
                let sectionTemplateId = sectionState.sectionTemplateId;

                let template = this.availableBundlePurchaseTemplates.find(template => template.forSectionTemplates.includes(sectionTemplateId));

                if (sectionState && template) {
                    return template.templateFilename;
                }

                return this.availableBundlePurchaseTemplates[0] ? this.availableBundlePurchaseTemplates[0].templateFilename : "";
            },
            selectedBundleId () {
                if (this.componentData.selectedBundleId) {
                    return this.componentData.selectedBundleId;
                }

                if (this.hasContext('bundle-overview-section')) {
                    const sectionNodeState = this.findNodeState(this.sectionId);
                    return sectionNodeState ? sectionNodeState.getSelectedBundle() : "";
                }

                if (this.isPageContext('bundle') && this.pageContext.params && this.bundles.filter( bundle => bundle.titleId === this.pageContext.params.slug).length ) {
                    return this.pageContext.params.slug;
                }

                return "";
            },
            myBundleData () {
                let bundleFound = {};

                this.bundles.map(bundle => {
                    if (bundle.titleId === this.selectedBundleId) {
                        bundleFound = bundle;
                    }
                })

                return bundleFound;
            },
            selectedLayout () {
                return this.componentData.template;
            }
        },
        methods: {
            applyMagicTemplatePreferences (componentDataToSync, newTemplateId) {
                // Apply the correct card type when changing template
                let template = this.availableBundlePurchaseTemplates.find(template => template.forSectionTemplates.includes(newTemplateId));

                if (template && template.templateFilename) {
                    componentDataToSync.template = template.templateFilename;
                }

                return componentDataToSync;
            },
        }
    }
</script>

